import React from "react";
import styled from "styled-components";

const Container = styled.div`
  /* max-width: 984px; */
  max-width: calc(1192px + 2rem);
  padding-left: 1rem;
  padding-right: 1rem;
  margin: 0 auto;
  text-align: ${(props) => (props.align ? props.align : "center")};
  margin-top: 100px;
  padding-bottom: ${(props) => (props.mb0 ? "0px" : "100px")};
  @media (max-width: 768px) {
    margin-top: 60px;
    margin-bottom: ${(props) => (props.mb0 ? "0px" : "60px")};
    padding-bottom: 0;
  }
  a {
    color: #000;
  }
  img {
    border-radius: 20px;
  }
  h2 {
    margin-bottom: 40px;
  }
  h3 {
    max-width: 1220px;
  }
  h3 + h3 {
    margin-top: 60px;
  }
  h4 {
    margin-bottom: 20px;
  }
  p + p {
    margin-top: 1rem;
  }
`;

const Text = (props) => {
  const { children, align, mb0 } = props;

  return (
    <Container mb0={mb0} align={align}>
      {children}
    </Container>
  );
};

export default Text;
